import { useEffect } from 'react'
import Modal from '@components/Modal'
import Button from '@components/Button'
import CircleLoader from '@components/CircleLoader'
import ErrorMessage from '@components/ErrorMessage'

import { getTermsAndConditions } from 'purchase-flow/canada/actions'
import {
    termsAndConditionsSelector,
    termsConditionsLoadingSelector,
    termsConditionsErrorSelector,
} from 'purchase-flow/canada/selectors'

const TermsAndConditions = ({ getTermsAndConditions, closeModal, termsConditions, loading, error }) => {
    useEffect(() => {
        getTermsAndConditions()
    }, [])

    return (
        <Modal withoutOutsideClick={true} onClose={closeModal} header={termsConditions?.title}>
            {!loading && error && <ErrorMessage className="mt-2" messages={[error]} />}
            {loading && !error ? (
                <CircleLoader className="m-auto" />
            ) : (
                <>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: termsConditions?.content,
                        }}
                    />
                    <Button btnStyle="outline" onClick={closeModal} className="mt-2 ml-auto">
                        <T>subscription.purchase.modal.label.close</T>
                    </Button>
                </>
            )}
        </Modal>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            termsConditions: termsAndConditionsSelector,
            loading: termsConditionsLoadingSelector,
            error: termsConditionsErrorSelector,
        }),
        {
            getTermsAndConditions,
        }
    )
)(TermsAndConditions)
